export const NO_IMAGE =
  "https://propularity-bucket.s3.ap-south-1.amazonaws.com/image-1706006993246.png";
